
<!--
1 hapatikani
2 hapokei
3 ahadi

-->
<template>
    <span v-if="Followup == 0" class="followup-badge followup-not-yet">Not Yet</span>
    <span v-if="Followup == 1" class="followup-badge followup-danger">Hapatikani</span>
    <span v-if="Followup == 2" class="followup-badge followup-warning">Hapokei</span>
    <span v-if="Followup == 3" class="followup-badge followup-success">Ahadi</span>
</template>

<script setup>

const props = defineProps({
  Followup: {
    type: Number,
    default: 1,
  },
});


</script>
